module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "sw-card",
    attrs: {
      "flat": "",
      "outlined": ""
    }
  }, [_c('div', {
    staticClass: "sw-marker",
    attrs: {
      "aria-label": _vm.markerLetter
    }
  }, [_vm._v(_vm._s(_vm.markerLetter))]), _vm._v(" "), _c('div', {
    staticClass: "sw-card-inner"
  }, [_c('div', {
    staticClass: "sw-body"
  }, [(!_vm.readonly) ? _c('div', {
    staticClass: "sw-actions"
  }, [(_vm.saving) ? _c('div', {
    staticClass: "sw-saving-wrap",
    attrs: {
      "aria-label": _vm.$t('FieldSurveyForm.saving')
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "22",
      "width": "2",
      "color": "#0091d5"
    }
  })], 1) : (_vm.editing) ? [_c('v-btn', {
    staticClass: "sw-icon-btn",
    attrs: {
      "icon": "",
      "small": "",
      "disabled": !_vm.canSave,
      "aria-label": _vm.$t('FieldSurveyForm.save')
    },
    on: {
      "click": _vm.submitEdit
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "22",
      "color": "#43a047"
    }
  }, [_vm._v("mdi-check")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "sw-icon-btn",
    attrs: {
      "icon": "",
      "small": "",
      "aria-label": _vm.$t('FieldSurveyForm.cancel')
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "22",
      "color": "#e53935"
    }
  }, [_vm._v("mdi-close")])], 1)] : [_c('v-btn', {
    staticClass: "sw-icon-btn",
    attrs: {
      "icon": "",
      "small": "",
      "disabled": _vm.deleting,
      "aria-label": _vm.$t('FieldSurveyForm.edit')
    },
    on: {
      "click": _vm.startEdit
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "18",
      "color": "#888"
    }
  }, [_vm._v("mdi-pencil")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "sw-icon-btn",
    attrs: {
      "icon": "",
      "small": "",
      "disabled": _vm.deleting || _vm.editing,
      "aria-label": _vm.$t('FieldSurveyForm.delete')
    },
    on: {
      "click": function($event) {
        _vm.deleteDialog = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "18",
      "color": "#888"
    }
  }, [_vm._v("mdi-delete-outline")])], 1)]], 2) : _vm._e(), _vm._v(" "), (!_vm.editing) ? [_c('div', {
    staticClass: "sw-title"
  }, [_vm._v(_vm._s(_vm.viewName || '—'))]), _vm._v(" "), _c('div', {
    staticClass: "sw-row"
  }, [_c('v-icon', {
    staticClass: "sw-row-icon",
    attrs: {
      "size": "16",
      "color": "#666"
    }
  }, [_vm._v("account-hard-hat")]), _vm._v(" "), _c('span', {
    staticClass: "sw-row-text"
  }, [_vm._v(_vm._s(_vm.viewUser || '—'))])], 1), _vm._v(" "), (_vm.serviceRows.length) ? _c('div', {
    staticClass: "sw-services"
  }, _vm._l((_vm.workServices), function(service) {
    return _c('v-chip', {
      key: service,
      staticClass: "ma-1",
      attrs: {
        "small": ""
      }
    }, [_vm._v(_vm._s(_vm.$t('EquipmentServices.' + service)))])
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sw-row"
  }, [_c('v-icon', {
    staticClass: "sw-row-icon",
    attrs: {
      "size": "16",
      "color": "#666"
    }
  }, [_vm._v("mdi-map-marker-outline")]), _vm._v(" "), _c('span', {
    staticClass: "sw-row-text"
  }, [_vm._v(_vm._s(_vm.viewCoordinates || '—'))])], 1), _vm._v(" "), _c('div', {
    staticClass: "sw-row sw-row-file"
  }, [_c('v-icon', {
    staticClass: "sw-row-icon",
    attrs: {
      "size": "16",
      "color": _vm.viewHasChart ? '#0091d5' : '#999'
    }
  }, [_vm._v("\n            " + _vm._s(_vm.viewHasChart ? 'mdi-file-document-outline' : 'mdi-file-remove-outline') + "\n          ")]), _vm._v(" "), (_vm.canOpenStoredChart) ? _c('button', {
    staticClass: "sw-file-open",
    attrs: {
      "type": "button",
      "disabled": _vm.openingChart,
      "aria-label": _vm.$t('FieldSurveyForm.chartView')
    },
    on: {
      "click": _vm.openStoredChart
    }
  }, [_vm._v("\n            " + _vm._s(_vm.viewChartLabel) + "\n          ")]) : _c('span', {
    class: _vm.viewHasChart ? 'sw-file-link' : 'sw-file-muted'
  }, [_vm._v(_vm._s(_vm.viewChartLabel))])], 1)] : [_c('v-text-field', {
    staticClass: "sw-mat-input sw-name-input",
    attrs: {
      "flat": "",
      "solo": "",
      "dense": "",
      "hide-details": "",
      "single-line": "",
      "placeholder": _vm.$t('FieldSurveyForm.fieldName')
    },
    model: {
      value: (_vm.draft.deviceName),
      callback: function($$v) {
        _vm.$set(_vm.draft, "deviceName", $$v)
      },
      expression: "draft.deviceName"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sw-field-row sw-field-row-select"
  }, [_c('v-icon', {
    staticClass: "sw-field-row-icon",
    attrs: {
      "size": "20",
      "color": "#444"
    }
  }, [_vm._v("mdi-account-hard-hat")]), _vm._v(" "), _c('survey-work-technician-select', {
    staticClass: "sw-field-grow",
    attrs: {
      "items": _vm.technicianItems,
      "loading": _vm.technicianOptionsLoading,
      "disabled": _vm.saving,
      "compact": true,
      "field-survey-id": _vm.fieldSurveyId
    },
    on: {
      "user-created": function($event) {
        return _vm.$emit('technician-user-created', $event)
      }
    },
    model: {
      value: (_vm.draft.userId),
      callback: function($$v) {
        _vm.$set(_vm.draft, "userId", $$v)
      },
      expression: "draft.userId"
    }
  })], 1), _vm._v(" "), (_vm.serviceRows.length) ? _c('survey-work-services', {
    attrs: {
      "rows": _vm.editableServiceRows,
      "disabled": _vm.saving
    },
    model: {
      value: (_vm.draft.services),
      callback: function($$v) {
        _vm.$set(_vm.draft, "services", $$v)
      },
      expression: "draft.services"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sw-field-row sw-field-row-coords"
  }, [_c('v-icon', {
    staticClass: "sw-field-row-icon",
    attrs: {
      "size": "20",
      "color": "#444"
    }
  }, [_vm._v("mdi-map-marker-outline")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "sw-mat-input sw-field-grow",
    attrs: {
      "flat": "",
      "solo": "",
      "dense": "",
      "single-line": "",
      "placeholder": _vm.$t('FieldSurveyForm.fieldCoordinates'),
      "hint": _vm.$t('NewCampaignInitialData.devicesAndServices.coordinatesHint'),
      "rules": _vm.coordinateRules,
      "hide-details": "auto",
      "validate-on-blur": ""
    },
    model: {
      value: (_vm.draft.coordinates),
      callback: function($$v) {
        _vm.$set(_vm.draft, "coordinates", $$v)
      },
      expression: "draft.coordinates"
    }
  })], 1), _vm._v(" "), _c('input', {
    ref: "chartFileInput",
    staticClass: "sw-file-input",
    attrs: {
      "type": "file",
      "accept": ".pdf,.png,.jpg,.jpeg,.webp,image/*,application/pdf",
      "disabled": _vm.saving
    },
    on: {
      "change": _vm.onChartFileSelected
    }
  }), _vm._v(" "), (_vm.showChartUploadPill) ? _c('button', {
    staticClass: "sw-chart-upload-pill",
    attrs: {
      "type": "button",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.openChartFilePicker
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "22",
      "color": "#757575"
    }
  }, [_vm._v("mdi-upload")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('FieldSurveyForm.chartUploadButtonLabel')))])], 1) : _c('div', {
    staticClass: "sw-chart-when-has-file mt-3"
  }, [_c('div', {
    staticClass: "sw-chart-status"
  }, [(_vm.canOpenEditChart) ? _c('button', {
    staticClass: "sw-file-open",
    attrs: {
      "type": "button",
      "disabled": _vm.saving || _vm.openingChart,
      "aria-label": _vm.$t('FieldSurveyForm.chartView')
    },
    on: {
      "click": _vm.openEditChart
    }
  }, [_vm._v("\n              " + _vm._s(_vm.editChartPathLabel) + "\n            ")]) : _c('span', [_vm._v(_vm._s(_vm.$t('FieldSurveyForm.chartWillRemove')))])]), _vm._v(" "), _c('div', {
    staticClass: "sw-chart-btns"
  }, [(_vm.pendingChartFile) ? [_c('v-btn', {
    staticClass: "px-1",
    attrs: {
      "text": "",
      "small": "",
      "color": "grey darken-1",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.clearPendingChartFile
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('FieldSurveyForm.chartClearSelection')) + "\n              ")])] : (_vm.markChartRemoved && _vm.initialHadChart) ? [_c('v-btn', {
    staticClass: "px-1",
    attrs: {
      "text": "",
      "small": "",
      "color": "#0091d5",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.openChartFilePicker
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('FieldSurveyForm.chartReplace')) + "\n              ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "px-1",
    attrs: {
      "text": "",
      "small": "",
      "color": "grey darken-1",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.undoRemoveChart
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('FieldSurveyForm.chartUndoRemove')) + "\n              ")])] : [_c('v-btn', {
    staticClass: "px-1",
    attrs: {
      "text": "",
      "small": "",
      "color": "#0091d5",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.openChartFilePicker
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('FieldSurveyForm.chartReplace')) + "\n              ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "px-1",
    attrs: {
      "text": "",
      "small": "",
      "color": "grey darken-1",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.removeChartForSave
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('FieldSurveyForm.chartRemove')) + "\n              ")])]], 2)])]], 2)]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "420",
      "content-class": "sw-delete-dialog-overlay"
    },
    on: {
      "click:outside": function($event) {
        _vm.deleteDialog = false
      }
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  }, [_c('v-card', {
    staticClass: "sw-delete-dialog-card",
    attrs: {
      "flat": ""
    }
  }, [_c('v-btn', {
    staticClass: "sw-delete-close",
    attrs: {
      "icon": "",
      "aria-label": _vm.$t('FieldSurveyForm.cancel'),
      "disabled": _vm.deleting
    },
    on: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#1e3a4c"
    }
  }, [_vm._v("mdi-close")])], 1), _vm._v(" "), _c('div', {
    staticClass: "sw-delete-inner"
  }, [_c('p', {
    staticClass: "sw-delete-message"
  }, [_vm._v(_vm._s(_vm.$t('FieldSurveyForm.deleteConfirmMessage')))]), _vm._v(" "), _c('div', {
    staticClass: "sw-delete-actions"
  }, [_c('v-btn', {
    staticClass: "sw-delete-btn-cancel",
    attrs: {
      "outlined": "",
      "depressed": "",
      "disabled": _vm.deleting
    },
    on: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('FieldSurveyForm.cancel')) + "\n          ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "sw-delete-btn-confirm",
    attrs: {
      "depressed": "",
      "loading": _vm.deleting
    },
    on: {
      "click": _vm.confirmDelete
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('FieldSurveyForm.delete')) + "\n          ")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f0a207a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FieldSurveys/SurveyWorkCard.vue
// module id = 1729
// module chunks = 0